module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"Long Awaited Updates Part 4: R.A.C.H.E.L. Undying Launch, New Website Launch, and more Brandon Sanderson!","path":"/website-launch-rachel-undying-dnd-brandon-sanderson"}}}]}},"pathContext":{"tag":"D&D"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-d-d.json
// module id = 434
// module chunks = 188663379315634